<template>
	<div class="main-content">
		<PromoBanner @apply-event-banner="applyEventBannerStyles"/>
	<!-- Start Hero Section -->
		<!-- <section class="hero-section gradient-overlay" id="home">
			<div ref="swiper" class="swiper-container main-slider">
				<div class="swiper-wrapper">

					<div class="swiper-slide">
						<div class="slide-inner slide-main">
							<div class="slide-content text-white text-center">
								<h2 class="mb-1 text-center">Project Spectrum</h2>
								<p class="text-white text-center h5">
									Continuously Monitoring and Securing Cyber
								</p>
								<b-button
									pill
									variant="outline-light"
									class="m-1"
									@click="$router.push('contact')"
									>Contact Us</b-button
								>
							</div>
						</div>
					</div>

					<div class="swiper-slide">
			<div class="slide-inner slide-mpp-summit">
				<div class="slide-content text-white text-center">
				<h2 class="mb-1 text-center">Project Spectrum at the Mentor Protégé Summit</h2>
				<p class="text-white text-center h5">Mentor Protégé Summit 2023</p>
             
				<b-button
					pill
					variant="outline-light"
					class="m-1"
					@click="OpenMPPSummitLearnMore()"
					>Learn More</b-button
				>
				<b-button
					pill
					variant="outline-light"
					class="m-1"
					@click="OpenMPPSummitRegister()"
					>Register</b-button
				>
              
				</div>
			</div>
			</div>

					<div class="swiper-slide">
						<div class="slide-inner slide-readiness">
							<div class="slide-content text-white text-center">
								<h2 class="mb-1 text-center">Cyber Readiness Check</h2>
								<p class="text-white text-center h5">
									Make your small business cyber secure
								</p>
								<b-button
									pill
									variant="outline-light"
									class="m-1"
									@click="$router.push('cyber-readiness-check')"
									>Take Readiness Check</b-button
								>
							</div>
							R
						</div>
					</div>


					<div class="swiper-slide">
						<div class="slide-inner slide-mpp">
							<div class="slide-content text-white text-center">
								<h2 class="mb-1 text-center">MPP Pilot Program</h2>
								<p class="text-white text-center h5">
									Apply for the MPP Pilot Program Offered by Project Spectrum
								</p>
								<b-button
									pill
									variant="outline-light"
									class="m-1"
									@click="$router.push('pilot-program')"
									>Register</b-button
								>
							</div>
						</div>
					</div>


			<div class="swiper-slide">
			<a href="https://www.projectspectrum.io/#/cyber-circuits-detail?id=c75ef425-a25d-4159-bedf-4fe1f6af322a">
				<div class="slide-inner slide-cmmc">
				<div class="slide-content text-white text-center">
				</div>
				</div>
			</a>
			</div>
		</div>
		<div class="swiper-button-next swiper-button-white"></div>
		<div class="swiper-button-prev swiper-button-white"></div>
		</div>
		</section> -->

		<SectionHero 
			:selectedBlueprint="timelineItem" 
			:isEventBannerVisible="hasEventBanner"
			@send-selected-segment="setSelectedTimelineItem"
			@scroll-to-blueprint="scrollToBlueprint"
			@back-button-clicked="handleBackButtonClick"
		/>
    <!--End Hero Section -->
    <!-- Start About Area -->
	<!-- NOTE: WHAT IS COMMENTED OUT BELOW SHOULD REMAIN AND NOT BE REMOVED FOR THE POSSIBILITY THAT IT WILL BE REQUESTED FOR DISPLAY WHEN THE VIDEO IS AVAILABLE -->
    <!-- <section class="about-area mt-5" id="aboutus">
      <div class="container">
		<v-row>
			<v-col lg="6" xl="6" md="6" sm="12" cols="12">
				<div class="d-flex flex-column cater-business">
					<div class="section-title">
						<span>WE CATER TO YOUR NEEDS</span>
					</div>
					<h2>Protect your business with us</h2>
					<ul class="mt-3 mb-3">
						<li>Show increased compliance with security standards impacting the small business community</li>
						<li>Connect with one of our capable Cyber Advisors to aid in cybersecurity journey</li>
						<li>Share best practices among small businesses within the Defense Industrial Base</li>
						<li>See all the ways Project Spectrum benefits the various sectors of the industry</li>
					</ul>
				</div>
			</v-col>

			<v-col lg="6" xl="6" md="6" sm="12" cols="12" class="d-flex flex-row justify-content-center align-items-center">
				<div class="about-text video-player-box video-player-container">
					<VideoPlayerWidget
						video-source="https://vjs.zencdn.net/v/oceans.mp4"
						video-type="video/mp4"
					/>
				</div>
			</v-col>
		</v-row>
      </div>
    </section> -->

	<!-- START OF THE SELECTED VIDEO DISPLAY -->
	<SelectedSectionVideo
		v-if="timelineItem && selectedVideo"
		:videoItem="selectedVideo"
		ref="videoSection"
	/>
	<!-- END OF THE SELECTED VIDEO DISPLAY -->

	<!-- START OF THE PROJECT SPECTRUM HOME PAGE VIDEO -->
	<HomePageVideo
		v-else-if="!selectedVideo && !selectedRoadmapTimeline"
	/>
	<!-- END OF THE PROJECT SPECTRUM HOME PAGE VIDEO -->

    <!-- End About Area -->
	<!-- Start Blueprint Drop Down Area -->
	<section class="mt-3" id="blueprint-options-list-container">
		<div class="container-fluid px-3 px-lg-5 px-xl-5">
			<v-row class="m-0">
				<v-col class="px-0">
					<div class="d-flex flex-column justify-content-start w-100">
						<div v-if="selectedRoadmapTimeline">
							<div class="d-flex flex-row justify-content-center section-title w-100">
								<span class="m-0">BLUEPRINT</span>
							</div>
							<div class="d-flex flex-row justify-content-center w-100">
								<span class="project-spectrum-title m-0 text-center">Don't know where to start?</span>
							</div>
							<div class="d-flex flex-row justify-content-center w-100">
								<span class="project-spectrum-title m-0 text-center">Let's build a quick road map for you</span>
							</div>
						</div>
						<div 
							class="blueprint-options d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column justify-content-center"
							:class="{
								'align-items-center': !isBlueprintOptionsOpened,
								'align-items-lg-start align-items-xl-start align-items-sm-center align-items-center': isBlueprintOptionsOpened,
							}"
						>
							<div 
								class="blueprint-option-title"
								:class="{
									'mb-2': !isBlueprintOptionsOpened,
									'mt-3': isBlueprintOptionsOpened,
								}"
							>
								<!-- {{ !timelineItem ? "I am here because" : "I am here because I want to learn" }} -->
						 I am here because I want to learn 
							</div>
							<div 
								id="blueprint-options-list"
								class="blueprint-options-container"
								:class="computeBlueoptionsLeftMargin"
								>
								<div 
									class="blueprint-option-item d-flex flex-column justify-content-center pl-2 mb-2" 
									@click="isBlueprintOptionsOpened = !isBlueprintOptionsOpened"
								>
									<v-container>
										<v-row>
											<v-col cols="11" class="p-0 d-flex justify-content-start align-items-center">
												{{ !timelineItem ? "Select an option" : `more on ${selectedBlueprintItemValue}` }}
											</v-col>
											<v-col cols="1" class="p-0 pr-1 d-flex justify-content-center">
												<font-awesome-icon
													style="max-width: 100% !important"
													size="2x" 
													:icon="isBlueprintOptionsOpened ? 'chevron-up' : 'chevron-down'"
												/>
											</v-col>
										</v-row>
									</v-container>
								</div>

								<div 
									v-if="isBlueprintOptionsOpened"
									class="blueprint-option-item d-flex flex-column justify-content-center pl-2 mb-2" 
									:class="{
										'selected-blueprint-option': option.optionItem === timelineItem
									}"
									v-for="option in blueprintOptionItems" 
									:key="option.optionItem"
									@click="setTimelinelineItemOption(option.optionItem)"
								>
									{{ option.optionValue }}
								</div>
							</div>
						</div>
					</div>
				</v-col>
			</v-row>
		</div>
	</section>
	<!-- End Blueprint Drop Down Area -->
    <!-- Start Roadmap Timeline Area -->
    <section v-show="timelineItem !== null && selectedRoadmapTimeline" class="section pt-0 pb-0 mt-5">
      <div class="container">
        <div class="section-cybersecurity z-index9">
          <h2 class="project-spectrum-title  text-center text-sm-start">{{ roadmapTimelineTitle }}</h2>
        </div>
        <div class="row">
          <div class="col-12">
            <RoadmapTimeline 
              :timelineItems="selectedRoadmapTimeline"
            />
          </div>
        </div>
      </div>
    </section>
	<!-- End Roadmap Timeline Area -->

	<!-- THIS SECTION OF HOME PAGE IS TEMPORARILY REMOVED UNTIL IT IS NEEDED LATER OR TO BE REMOVED PERMANENTLY -->
	<!-- Start Services Bottom Area -->
	<!--section class="section pt-0 pb-0 mt-5">
		<div class="container">
			<v-row>
				<v-col cols="12" class="d-flex flex-column justify-content-start">
					<div class="d-flex flex-row justify-content-center section-title">
                        <span>WE CATER TO YOUR NEEDS</span>
                    </div>
                    <div class="d-flex just-row justify-content-center">
                        <span class="project-spectrum-title">Protect your business with us</span>
                    </div>
				</v-col>
			</v-row>

			<v-row class="business-items mt-3 mb-3 d-none d-md-flex d-lg-flex d-xl-flex">
				<v-col 
					:style="{
						'backgroundColor': selectedBusinessAssetItem !== asset.assetItem ? '#F8F9FC' : '#E9ECF5'
					}"
					xl="3" 
					lg="3"
					md="6"
					sm="6"
					cols="12" 
					class="business-item" 
					:class="businessItem"
					v-for="asset in businessAssets" 
					:key="asset.assetItem" 
					@click="selectBusinessItemOptions(asset.assetItem)"
				>
					<img 
						class="business-item-image"
						:src="require(`../assets/images/businesses/${asset.assetImageSrc}`)" 
						alt=""
					>
				</v-col>
			</v-row>

			<v-row class="mt-4 mb-2">
				<v-col
					xl="4"
					lg="4"
					md="6"
					cols="12"
					class="left-relevant-information"
				>
					<div class="d-flex flex-row justify-content-center justify-content-sm-center justify-content-lg-start just-content-lx-start">
						<img 
							class="mb-3"
							src="../assets/images/businesses/masterbrandlogoPS.png" 
							alt=""
							width="100%"
							height="100px"
						>
					</div>

					<div class="d-flex d-sm-none">
						<v-row>
							<v-col cols="12">
								<div class="button-container">
									<v-btn
										rounded
										large
										dark
										color="#424EC4"
										@click="setOverviewText"
									>
										OVERVIEW
									</v-btn>
								</div>
							</v-col>
						</v-row>
					</div>

					<div v-show="isOverviewVisible">
						<div class="relevant-information-text mt-3">
							<h6 class="my-3">OVERVIEW</h6>
							<p>Project Spectrum is an all-inclusive learning platform that provides resources, tools, training materials and videos about cybersecurity best practices. Project Spectrum is focused on preparing companies for Cybersecurity Maturity Model Certification (CMMC). The CMMC aims to improve cybersecurity practices in the Defense Industrial Base (DIB), providing assessment guidelines and certification with security standards such as NIST SP 800-171 and NIST SP 800-172.</p>
						</div>
						<div class="relevant-information-text mt-3">
							<h6 class="my-3">MISSION</h6>
							<p>Project Spectrum's goal is to improve cybersecurity readiness, strength, and compliance for small businesses, manufacturers, government agencies, universities and schools. Project Spectrum's cybersecurity courses are backed by the Department of Defense (DoD) and help prepare businesses for CMMC evaluation.</p>
						</div>
						<div class="relevant-information-text mt-3">
							<h6 class="my-3">FEATURES</h6>
							<ul style="margin-left: 12px;"> 
								<li>
									<b>Cyber Readiness Assessment</b>:&nbsp;This test helps businesses find out how prepared they are for a cyber threat or attack.
								</li><br>

								<li>
									<b>Customized Cybersecurity Journey</b>:&nbsp;Project Spectrum is customizable for each business needs and to improve their security standing.
								</li><br>

								<li>
									<b>Cyber Advisors</b>:&nbsp;Advisors are available to help businesses along their journey to improve their cybersecurity measures.<br>
								</li><br>

								<li>
									<b>Community</b>:&nbsp;Small business users in the DIB can share tips and best practices that improved their cybersecurity posture.
								</li>
							</ul>
						</div>
					</div>
				</v-col>

				<v-row class="business-items mt-3 mb-3 d-flex d-sm-none d-none d-sm-flex d-md-none mr-1 ml-1">
					<font-awesome-icon
						style="position: absolute; top: 40; right: 20; z-index: 100;"
						size="2x" 
						:icon="isMobileBusinessAssetItemsOpened ? 'chevron-up' : 'chevron-down'"
						@click="openMobileBusinessItemOptions"
					/>
					<v-col 
						:style="{
							'backgroundColor': selectedBusinessAssetItem !== asset.assetItem ? '#F8F9FC' : '#E9ECF5'
						}"
						cols="12" 
						class="business-item" 
						v-for="asset in mobileBusinessAssets" 
						v-show="selectedBusinessAssetItem === asset.assetItem || isMobileBusinessAssetItemsOpened"
						:key="asset.assetItem" 
						@click="selectedBusinessAssetItem === asset.assetItem ? openMobileBusinessItemOptions() : selectBusinessItemOptions(asset.assetItem)"
					>
						<img 
							class="business-item-image" 
							style="height: 125px;"
							:style="{
								'paddingLeft': isMobileView ? asset.assetItem === 'SmallBusinesses' ? '12%' : '17.5%' : '0px'
							}"
							:src="require(`../assets/images/businesses/${asset.assetImageSrc}`)" 
							alt=""
						>
					</v-col>
				</v-row>

				<v-col
					xl="8"
					lg="8"
					md="6"
					cols="12"
				>
					<div class="w-100 p-3">
						<div class="relevant-information-text">
							<h6>{{`FOCUS - ${businessAssetMap[selectedBusinessAssetItem]}`}}</h6>
							<p v-show="selectedBusinessAssetItem === 'DefenseIndustrialBase'">It's important that government agencies follow cybersecurity standards to ensure data privacy, manage risk, and fulfill legal obligations. With government agencies relying on technology to manage systems, cyber-attacks can disrupt government services, affecting citizens, businesses, and public safety.</p>
							<p v-show="selectedBusinessAssetItem === 'SmallBusinesses'">A 2021 Data Breach Investigations Report conducted by Verizon found 46% of breaches impacted businesses with less than 1000 employees. The investigation also found that small businesses 61% of targeted cyber attacks against business. Based on these findings, its likely a small business' customer data could be compromised.</p>
							<p v-show="selectedBusinessAssetItem === 'Manufacturing'">Manufacturing companies have increasing risk of cyber security threat as they integrate information technology into their manufacturing process. A cyber security attack could cause a disruption in the supply chain.</p>
							<p v-show="selectedBusinessAssetItem === 'MPP'">
								<span>The DoD Mentor-Protégé Program strives to be a model of effective public-private partnership, driving innovation, growth, and resilience within the defense sector. By supporting small businesses, the program ensures that the DoD has access to a diverse and capable pool of suppliers that can meet current and future defense needs. Mentor-Protégé Program (MPP) provides a structured framework for the development and growth of small businesses within the defense industrial base. The program aims to:</span>
								<ul class="m-0 ml-3 mt-2">
									<li>Foster long-term business relationships between large prime contractors and small businesses.</li>
									<li>Enhance the capabilities of small businesses to compete more effectively for prime contracts and subcontracts.</li>
									<li>Contribute to the diversification and resilience of the defense supply chain.</li>
									<li>Support the development of a skilled workforce and innovative solutions that meet the evolving needs of the Department of Defense.</li>
								</ul>
							</p>
						</div>
						<div v-if="selectedBusinessAssetItem !== 'MPP'" class="relevant-information-text mt-3">
							<h6>REAL WORLD SCENARIO</h6>
							<p v-show="selectedBusinessAssetItem === 'DefenseIndustrialBase'">Hackers known as Cyber Avengers attacked the Municipal Water Authority of Aliquippa. They compromised the software Unitronics, which is Israeli owned, used to control the water system. They got control of one of the booster stations that monitors and regulates water pressure for Raccoon and Potter Townships. The attack temporarily stopped pumping at the station, affecting water pressure for the nearby towns.</p>
							<p v-show="selectedBusinessAssetItem === 'SmallBusinesses'">In 2023, a small distribution company, Bright Tone, Inc, experienced a significant Cyber breach incident, resulting in a $ 2.5 million settlement with the Threat Actor.  The incident was caused by not changing the default credentials on the firewall allowing for a simple intrusion. The intrusion was easily preventable but also easily overlooked by their small IT Team.</p>
							<p v-show="selectedBusinessAssetItem === 'Manufacturing'">In March 2024, a windows manufacturing company named Windows America, Inc. suffered a simple factory floor cyber incident as a result of out dated factory control PCs.  The small workstations were in a harsh environment and running outdated Windows software.  The control units were also on the company's main network allowing for easy infection throughout the network.</p>
						</div>
						<div class="relevant-information-text mt-3">
							<h6>{{ selectedBusinessAssetItem === 'MPP' ? "BENEFITS" : "SERVICE" }}</h6>
							<p v-show="selectedBusinessAssetItem === 'DefenseIndustrialBase'">Government agencies might consider Project Spectrums CMMC Level 2 course or MPP program.</p>
							<p v-show="selectedBusinessAssetItem === 'SmallBusinesses'">A small business might consider Project Spectrums' CMMC Level 1 course.</p>
							<p v-show="selectedBusinessAssetItem === 'Manufacturing'">A small manufacturing company might consider Project Spectrums' CMMC Level 1 course.<br>A large manufacturing company or one that has government contracts might consider Project Spectrums' CMMC Level 2 course.</p>
							<ul v-show="selectedBusinessAssetItem === 'MPP'" class="m-0 ml-3">
								<li><b>For Protégés:</b> Access to the expertise, resources, and capabilities of larger companies to enhance their business operations and competitiveness.</li>
								<li><b>For Mentors:</b> Fulfillment of subcontracting goals and potential for contract credits or reimbursement, along with the opportunity to contribute to the growth of the defense industrial base.</li>
							</ul>
						</div>
						<div class="relevant-information-text mt-3">
							<h6>TARGET AUDIENCE</h6>
							<ul v-show="selectedBusinessAssetItem === 'DefenseIndustrialBase'" class="m-0 target-audiences">
								<li>Information Security Analyst</li>
								<li>Incident Response Analyst</li>
								<li>Security Compliance Officers</li>
								<li>Network Security Administrators</li>
							</ul>

							<ul v-show="selectedBusinessAssetItem === 'SmallBusinesses'" class="m-0 target-audiences">
								<li>Small business owners</li>
								<li>IT employees</li>
								<li>Employees working with sensitive data</li>
							</ul>

							<ul v-show="selectedBusinessAssetItem === 'Manufacturing'" class="m-0 target-audiences">
								<li>Network Administrators for manufacturing companies</li>
								<li>Quality assurance managers</li>
								<li>Supply chain managers</li>
							</ul>

							<ul v-show="selectedBusinessAssetItem === 'MPP'" class="m-0 target-audiences">
								<li>Small Businesses</li>
								<li>Small Disadvantaged Businesses (SDBs)</li>
								<li>Women-Owned Small Businesses (WOSBs)</li>
								<li>Service-Disabled Veteran-Owned Small Businesses (SDVOSBs)</li>
								<li>HUBZone Small Businesses</li>
								<li>Large Prime Contractors</li>
								<li>Defense Contractors</li>
								<li>Innovative Technology Firms</li>
								<li>Government Agencies and Organizations</li>
								<li>DoD Contracting Offices</li>
								<li>Small Business Administration (SBA)</li>
								<li>Industry Associations and Advocacy Groups</li>
								<li>Trade Associations</li>
							</ul>
						</div>
					</div>
				</v-col>
			</v-row>
		</div>
	</section-->
    <!-- End Services Bottom Area -->

		<!-- Start Portfolio Area -->
		<!-- <section class="section pt-0 portfolio-section" id="portfolio">
      <div class="container">
        <div class="section-title text-center z-index9">
          <span>OUR PROJECTS</span>
          <h2>What We Offer?</h2>
        </div>
        <div
          class="d-flex justify-content-center wow fadeIn"
          data-wow-duration="1s"
        >
          <ul id="portfolio-filter" class="portfolio-filter filters mt-4 p-0">
            <li class="button-border list-inline-item">
              <a href="#" data-filter="*" class="pill-button">All</a>
            </li>
            <li class="button-border list-inline-item">
              <a href="#" data-filter=".courses" class="pill-button"
                >Training Courses</a
              >
            </li>
            <li class="button-border list-inline-item">
              <a href="#" data-filter=".cybertools" class="pill-button"
                >Cyber Tools</a
              >
            </li>
            <li class="button-border list-inline-item">
              <a href="#" data-filter=".compliance" class="pill-button"
                >Compliance</a
              >
            </li>
          </ul>
        </div>
        <div
          class="portfolio-items row no-gutters mt-4 wow fadeIn"
          data-wow-duration="1s"
        >
          <div class="row align-items-center mt-4 courses">
            <div class="col-lg-5">
              <iframe
                class="video d-block"
                height="250"
                width="100%"
                controls
                src="https://www.youtube.com/embed/XXmjx02wLuM"
              />
            </div>
            <div class="col-lg-7">
              <div
                class="feature-contents section-heading wow fadeInUp"
                data-wow-duration="1s"
              >
                <h1 class="font-18">Training and Workforce</h1>
                <p>
                  Our Training Videos comprise brief, easy-to-understand
                  educational snippets that provide cybersecurity tips and
                  information about the Cybersecurity Maturity Model
                  Certification (CMMC).
                </p>
                <div class="d-flex justify-content-left mt-4">
                  <button class="btn outline-theme-btn">
                    Watch Training Videos
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row align-items-center mt-4 cybertools">
            <div class="col-lg-5">
              <iframe
                class="video d-block"
                height="250"
                width="100%"
                controls
                src="https://www.youtube.com/embed/XXmjx02wLuM"
              />
            </div>
            <div class="col-lg-7">
              <div
                class="feature-contents section-heading wow fadeInUp"
                data-wow-duration="1s"
              >
                <h1 class="font-18">Cybersecurity Tools</h1>
                <p>
                  Our Training Videos comprise brief, easy-to-understand
                  educational snippets that provide cybersecurity tips and
                  information about the Cybersecurity Maturity Model
                  Certification (CMMC).
                </p>
                <div class="d-flex justify-content-left mt-4">
                  <button class="btn outline-theme-btn">
                    Watch Training Videos
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row align-items-center mt-4 compliance">
            <div class="col-lg-5">
              <iframe
                class="video d-block"
                height="250"
                width="100%"
                controls
                src="https://www.youtube.com/embed/XXmjx02wLuM"
              />
            </div>
            <div class="col-lg-7">
              <div
                class="feature-contents section-heading wow fadeInUp"
                data-wow-duration="1s"
              >
                <h1 class="font-18">Compliance Tools</h1>
                <p>
                  Our Training Videos comprise brief, easy-to-understand
                  educational snippets that provide cybersecurity tips and
                  information about the Cybersecurity Maturity Model
                  Certification (CMMC).
                </p>
                <div class="d-flex justify-content-left mt-4">
                  <button class="btn outline-theme-btn">
                    Watch Compliance Videos
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
		<!-- <section class="section pt-0 portfolio-section" id="portfolio">
      <div class="container">
        <div class="section-title text-center z-index9">
          <h2>Project Spectrum Overview</h2>
        </div>
        <br />
        <center>
          <div class="col-lg-8 embed-youtube">
            <iframe
              class="video d-block"
              height="390"
              width="640"
              controls
              src="https://www.youtube.com/embed/a_v7zKoOcG4"
            />
          </div>
        </center>
      </div>
    </section> -->
		<!-- End Testimonial Area -->
		<!-- Start Jumbstrom Area -->
		<!-- <section class="section parallax-bg">
			<div class="container">
				<div class="z-index9 wow fadeIn" data-wow-duration="1s">
					<h2 class="text-white text-center">
						Make your small business cyber secure
					</h2>
					<p class="mb-1" style="color: white; text-align: center">
						An estimated 43% of small businesses fall victim to cyberattacks
						annually.
					</p>
					<p style="color: white; text-align: center">
						Take our cyber readiness assessment to determine how prepared your
						business is to deal with cyberattacks.
					</p>
					<div class="d-flex justify-content-center mt-4">
						<b-button
							pill
							variant="outline-light"
							class="outline-theme-btn"
							@click="$router.push('cyber-readiness-check')"
							>Take Readiness Check</b-button
						>
					</div>
				</div>
			</div>
		</section> -->
		<!-- <section class="section mb-0 pb-0" id="portfolio">
      <div class="container">
        <div class="section-title text-center z-index9">
          <span>ATTEND OUR</span>
          <h2>Recent Events</h2>
        </div>
        <div
          class="d-flex justify-content-center wow fadeIn"
          data-wow-duration="1s"
        >
          <ul id="portfolio-filter" class="portfolio-filter filters mt-4 p-0">
            <li class="button-border list-inline-item">
              <a href="#" @click="setDataFilter(0)" class="pill-button">All</a>
            </li>
            <li class="button-border list-inline-item">
              <a href="#" @click="setDataFilter(1)" class="pill-button"
                >Webinars</a
              >
            </li>
            <li class="button-border list-inline-item">
              <a href="#" @click="setDataFilter(2)" class="pill-button"
                >Cyber Circuits</a
              >
            </li>
          </ul>
        </div>
        <div
          class="portfolio-items row no-gutters mt-4 wow fadeIn"
          data-wow-duration="1s"
          v-if="
            cybercircuitItems.length > 0 && (datafilter == 0 || datafilter == 2)
          "
        >
          <div class="blog-post-grid">
            <div class="row">
              <div
                class="col-lg-4 col-sm-6 mb-5"
                v-for="item in cybercircuitItems"
                :key="item.id"
              > -->
		<!-- Cyber Circuit Card -->
		<!-- <div class="blog-item border h-100">
                  <router-link
                    class="blog-post-image"
                    :to="{
                      name: 'cyber-circuits-detail',
                      query: { id: item.id },
                    }"
                  >
                    <img
                      :src="item.cyberBannerLink"
                      :alt="item.photoDescription"
                      class="cover"
                    />
                  </router-link>
                  <div class="blog-post-info">
                    <router-link
                      class="text-dark"
                      :to="{
                        name: 'cyber-circuits-detail',
                        query: { id: item.id },
                      }"
                    >
                      <h4 class="blog-post-title">
                        {{ item.title }}
                      </h4>
                      <p class="limit-lines-2">{{ item.headLine }}</p>
                      <div class="post-event-bottom d-flex align-items-center">
                        <a class="blog-info-meta text-dark">{{
                          getFormattedDate(item.date)
                        }}</a>
                        <a class="blog-category text-dark">Cyber Circuits</a>
                      </div>
                    </router-link>
                    <router-link
                      class="blog-read-more"
                      :to="{
                        name: 'cyber-circuits-detail',
                        query: { id: item.id },
                      }"
                    >
                      <i class="mdi mdi-arrow-right"></i>
                    </router-link>
                  </div>
                </div> -->
		<!-- End Cyber Circuit Card -->
		<!-- </div>
            </div>
          </div>
        </div>
        <div
          class="portfolio-items row no-gutters mt-4 wow fadeIn webinars"
          data-wow-duration="1s"
          v-if="webinarItems.length > 0 && (datafilter == 0 || datafilter == 1)"
        >
          <div class="blog-post-grid">
            <div class="row">
              <div
                class="col-lg-4 col-sm-6 mb-5 portfolio-item box"
                v-for="item in webinarItems"
                :key="item.id"
              > -->
		<!-- Event Card -->
		<!-- <div class="blog-item border h-100">
                  <router-link
                    class="blog-post-image"
                    :to="{ name: 'event-detail', query: { id: item.id } }"
                  >
                    <img
                      src="../assets/images/services/webinar.jpeg"
                      class="cover"
                    />
                  </router-link>
                  <div class="blog-post-info">
                    <router-link
                      class="text-dark"
                      :to="{ name: 'event-detail', query: { id: item.id } }"
                    >
                      <h4 class="blog-post-title">
                        {{ item.eventTitle }}
                      </h4> -->
		<!-- <p class="limit-lines">{{item.description}}</p> -->
		<!-- <b-badge
                        v-if="item.registrationRequired"
                        class="mb-1 badge-required"
                        >Registration Required</b-badge
                      >
                      <b-badge
                        v-if="!item.registrationRequired"
                        class="mb-1 badge-not-required"
                        >No Registration Required</b-badge
                      >
                      <div class="post-event-bottom d-flex align-items-center">
                        <a class="blog-info-meta text-dark">{{
                          getFormattedDate(item.startAt)
                        }}</a>
                        <a class="blog-category text-dark">Webinar</a>
                      </div>
                    </router-link>
                    <router-link
                      class="blog-read-more"
                      :to="{ name: 'event-detail', query: { id: item.id } }"
                    >
                      <i class="mdi mdi-arrow-right"></i>
                    </router-link>
                  </div>
                </div> -->
		<!-- End Event Card -->
		<!-- </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
		<!-- <section class="section pt-0 testimonial-section" id="news">
      <div
        class="testimonial-header-area bg-image"
        data-image-src="assets/images/testi/cybersecurity.jpeg"
      >
        <div class="container">
          <div class="text-center section-title" style="margin-bottom: 20px">
            <span>READ OUR</span>
            <h2 style="color: white">Latest News</h2>
          </div>
        </div>
      </div> -->
		<!-- <div class="testimonial-content-area wow fadeIn" data-wow-duration="1s">
        <div class="container">
          <div class="row">
            <div
              class="col-md-6 col-lg-4 mb-5"
              v-for="item in items"
              :key="item.id"
            >
              <div class="blog-item border h-100">
                <router-link
                  class="blog-post-image"
                  :to="{ name: 'newsdetail', query: { id: item.id } }"
                >
                  <img
                    :src="item.article.largeImageURL"
                    :alt="item.photoDescription"
                    class="cover"
                  />
                </router-link>
                <div class="blog-post-info">
                  <router-link
                    class="text-dark"
                    :to="{ name: 'newsdetail', query: { id: item.id } }"
                  >
                    <h4 class="blog-post-title">
                      {{ item.article.title }}
                    </h4>
                    <p class="limit-lines-3">{{ item.article.headLine }}</p>
                    <div class="post-event-bottom d-flex align-items-center">
                      <a class="blog-info-meta text-dark">{{
                        getFormattedDate(item.article.date)
                      }}</a>
                      <a class="blog-category text-dark">News</a>
                    </div>
                  </router-link>
                  <router-link
                    class="blog-read-more"
                    :to="{ name: 'newsdetail', query: { id: item.id } }"
                  >
                    <i class="mdi mdi-arrow-right"></i>
                  </router-link>
                </div>
              </div> -->
		<!-- <div class="testimonial-item bg-white">
                <h6 class="client-title font-20 limit-lines-2">
                  {{ item.article.title }}
                </h6>
                <figure class="client-thumb">
                  <img
                    :src="item.article.largeImageURL"
                    class="news-cover-small"
                    alt="Client"
                  />
                </figure>
                <p class="mb-0 limit-lines-3">{{ item.article.headLine }}</p>
                <p class="mb-0">
                  {{ getFormattedDate(item.article.date) }}
                </p>
                <router-link
                  class="blog-read-more"
                  :to="{ name: 'newsdetail', query: { id: item.id } }"
                >
                  <i class="mdi mdi-arrow-right"></i>
                </router-link>
              </div> -->
		<!-- </div>
          </div>
        </div>
      </div>
    </section> -->
		<!-- <VueBotUI
      :messages="messageData"
      :options="botOptions"
      :bot-typing="botTyping"
      :input-disable="inputDisable"
      @init="botStart"
      @msg-send="msgSend"
    /> -->
		<!-- End Services Bottom Area -->
		<!-- <section class="section pt-0 testimonial-section" id="portfolio">
            <div class="container">
				<br>
                <div class="section-title text-center z-index9">
					<span>ATTEND OUR</span>
                    <h2>Recent Events</h2>
                </div>
                <div class="d-flex justify-content-center wow fadeIn" data-wow-duration="1s">
                    <ul id="portfolio-filter" class="portfolio-filter filters mt-4 p-0">
						<li class="button-border list-inline-item">
                            <a href="#" @click="setDataFilter(0)" class="pill-button">All</a>
                        </li>
                        <li class="button-border list-inline-item">
                            <a href="#" @click="setDataFilter(1)" class="pill-button">Webinars</a>
                        </li>
                        <li class="button-border list-inline-item">
                            <a href="#" @click="setDataFilter(2)" class="pill-button">Cyber Circuits</a>
                        </li>
                    </ul>
                </div>
			<div class="portfolio-items row no-gutters mt-4  wow fadeIn" data-wow-duration="1s" v-if="cybercircuitItems.length > 0 && (datafilter == 0 || datafilter == 2)">
                <div class="col-lg-4 col-sm-6 cybercircuits box" v-for="item in cybercircuitItems" :key="item.id">
                    <div class="blog-item border mb-5" style="height:400px">
                        <router-link class="blog-post-image" :to="{ name: 'cyber-circuits-detail', params: { item } }">
                            <img :src="item.cyberBannerLink" class="cover">
                        </router-link>
                        <div class="blog-post-info">
                            <h4 class="blog-post-title">
                                    {{item.title}}
                            </h4>
                            <p>{{item.headLine}}</p>
                            <div class="post-event-bottom d-flex align-items-center">
                                <a href="#" class="blog-info-meta text-dark"><strong> {{getFormattedDate(item.date)}} </strong></a>
                            </div>
                            <router-link class="blog-read-more" :to="{ name: 'cyber-circuits-detail', params: { item } }">
                                <i class="mdi mdi-arrow-right"></i>
                            </router-link>                               
                        </div>
                    </div>
                </div>
			</div>
				<div class="portfolio-items row no-gutters mt-4  wow fadeIn webinars" data-wow-duration="1s" v-if="webinarItems.length > 0 && (datafilter == 0 || datafilter == 1)">
					<div class="col-lg-4 col-sm-6  mb-5 portfolio-item box" v-for="item in webinarItems" :key="item.id">
						<div class="blog-item border" style="height:400px" >
							<router-link class="blog-post-image" to="/blogdetail">
								<img src="../assets/images/services/webinar.jpeg" class="cover">
							</router-link>
                                    <div class="blog-post-info">
                                        <h4 class="blog-post-title">
                                                {{item.eventTitle}}
                                        </h4>
										<p v-html="item.description"> </p>
                                        <div class="post-event-bottom d-flex align-items-center">
                                            <a href="#" class="blog-info-meta text-dark"><strong> {{item.startAt}} </strong></a>
                                        </div>
                                        <router-link class="blog-read-more" to="/blogdetail">
                                            <i class="mdi mdi-arrow-right"></i>
                                        </router-link>                               
                                    </div>
						</div>
                    </div>
				</div>
			</div>
		 </section> -->

		<!-- <section class="section pt-0 testimonial-section" id="news">
			<div
				class="testimonial-header-area bg-image"
				data-image-src="assets/images/testi/cybersecurity.jpeg"
			>
				<div class="container">
					<div class="text-center section-title">
						<span>READ OUR</span>
						<h2>Latest News</h2>
					</div>
				</div>
			</div>
			<div
				class="testimonial-content-area wow fadeIn"
				style="height: 400px"
				data-wow-duration="1s"
			>
				<div class="container">
					<div class="row">
						<div class="col-md-6 col-lg-4" v-for="item in items" :key="item.id">
							<div class="testimonial-item bg-white" style="height: 400px">
								<h6 class="client-title font-20 limit-lines">
									{{ item.article.title }}
								</h6>
								<figure class="client-thumb">
									<img
										:src="item.article.largeImageURL"
										class="news-cover-small"
										alt="Client"
									/>
								</figure>
								<p class="mb-0 limit-lines">{{ item.article.headLine }}</p>
								<p class="mb-0">
									<strong> {{ getFormattedDate(item.article.date) }} </strong>
								</p>
								<router-link
									class="blog-read-more"
									:to="{ name: 'newsdetail', params: { item } }"
								>
									<i class="mdi mdi-arrow-right"></i>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section> -->

		<!-- End Jumbstrom Area -->
		<section style="padding-bottom: 50px;" class="section pt-0" id="news">
			<div class="container">
				<div class="text-center section-title">
					<span class="section-title">READ OUR</span>
					<h2 class="project-spectrum-title ">Latest News</h2>
				</div>
			</div>
			<div class="wow fadeIn" data-wow-duration="1s">
				<div class="container">
					<newsLists />
				</div>
			</div>

			<!-- <b-button class="btn-more" size="sm">Read More</b-button> -->
			<div class="d-flex justify-content-center mt-4">
				<ButtonReadMore
					:link="{
						name: 'news',
					}"
					:clickHandler="() => activateMenuItemTab('Cyber Corner')"
					>Read More</ButtonReadMore
				>
			</div>
		</section>

		<!-- Start Company Partners Section -->
		<section>
			<div class="container-fluid company-partners-container d-flex flex-column">
				<div 
					class="d-flex flex-row flex-fill company-partners-container-text-info pt-5"
					:style="{ 'marginBottom': computeCompanyPartnerTextContainerClass }"
				>
					<v-row>
						<v-col 
							xl="6" 
							lg="6" 
							cols="12" 
							class="text-center d-flex flex-row justify-content-xl-end align-items-xl-center justify-content-lg-end align-items-lg-center justify-content-center align-items-end p-0 pr-2"
							:class="computeCompanyPartnerTextClass"
						>
							Project Spectrum serves 15000+ 
						</v-col>
						<v-col 
							xl="6" 
							lg="6" 
							cols="12" 
							class="text-center d-flex flex-row justify-content-xl-start align-items-xl-center justify-content-lg-start align-items-lg-center justify-content-center p-0 pl-0"
							:class="computeCompanyPartnerTextClass"
						>
							companies under these partnerships
						</v-col>
					</v-row>
				</div>
				<div class="d-flex flex-row flex-fill">
					<v-row>
						<v-col 
							xl="4" 
							lg="4" 
							cols="12"
							class="pl-0 pr-0"
						>
							<div class="h-100 d-flex align-items-center">
								<v-row>
									<v-col cols="4" class="d-flex justify-content-center">
										<v-img
											:src="require('../assets/images/logo/company-partners/image_32.png')"
											max-width="40%"
											contain
										>
										</v-img>
									</v-col>
									<v-col cols="4" class="d-flex justify-content-center">
										<v-img
											:src="require('../assets/images/logo/company-partners/image_35.png')"
											max-width="80%"
											contain
										>
										</v-img>
									</v-col>
									<v-col cols="4" class="d-flex justify-content-center">
										<v-img
											:src="require('../assets/images/logo/company-partners/image_36.png')"
											max-width="40%"
											contain
										>
										</v-img>
									</v-col>
								</v-row>
							</div>
						</v-col>
						<v-col 
							xl="4" 
							lg="4" 
							cols="12"
							class="pr-0 pl-0"
						>
							<div class="h-100 d-flex align-items-center">
								<v-row>
									<v-col cols="4" class="d-flex justify-content-center">
										<v-img
											:src="require('../assets/images/logo/company-partners/image_37.png')"
											max-width="40%"
											contain
										>
										</v-img>
									</v-col>
									<v-col cols="4" class="d-flex justify-content-center">
										<v-img
											:src="require('../assets/images/logo/company-partners/image_38.png')"
											max-width="80%"
											contain
										>
										</v-img>
									</v-col>
									<v-col cols="4" class="d-flex justify-content-center">
										<v-img
											:src="require('../assets/images/logo/company-partners/image_39.png')"
											max-width="70%"
											contain
										>
										</v-img>
									</v-col>
								</v-row>
							</div>
						</v-col>
						<v-col 
							xl="4" 
							lg="4" 
							cols="12"
							class="pl-0 pr-0"
						>
							<div class="h-100 d-flex align-items-center">
								<v-row>
									<v-col cols="4" class="d-flex justify-content-center">
										<v-img
											:src="require('../assets/images/logo/company-partners/image_40.png')"
											max-width="60%"
											contain
										>
										</v-img>
									</v-col>
									<v-col cols="4" class="d-flex justify-content-center">
										<v-img
											:src="require('../assets/images/logo/company-partners/image_41.png')"
											max-width="40%"
											contain
										>
										</v-img>
									</v-col>
									<v-col cols="4" class="d-flex justify-content-center pl-0 pr-0 last-image-class">
										<v-img
											:src="require('../assets/images/logo/company-partners/image_42.png')"
											max-width="100%"
											contain
										>
										</v-img>
									</v-col>
								</v-row>
							</div>
						</v-col>
					</v-row>
				</div>
			</div>
		</section>
		<!-- End Company Partners Section -->

		<!-- Start Department of Defense Relationship -->
		<section>
			<div class="container-fluid customer-relationship-container">
				<div class="container customer-relationship-content">
					<v-row>
						<v-col cols="12">
							<div 
								:style="{ 'fontSize': resizeCustomerTitle }" 
								class="d-flex justify-content-center align-items-center customer-relationship-title"
							>
								The Relationship with the Department of Defense
							</div>
						</v-col>
						<v-col cols="12">
							<div class="customer-relationship-text">
								<img src="../assets/images/logo/check.png" alt="">
								&nbsp;
								<span>The Department of Defense has entrusted Project Spectrum to be the cornerstone of cybersecurity for small and mid-size businesses of Defense Industrial Base.</span>
							</div>
							<div class="customer-relationship-text">
								<img src="../assets/images/logo/check.png" alt="">
								&nbsp;
								<span>Select "Get Started Today!" to begin your cybersecurity journey.</span>
							</div>
						</v-col>
						<v-col cols="12">
							<div class="button-container">
								<v-btn
									rounded
									large
									dark
									color="#424EC4"
									@click="goToCyberReadinessCheck"
								>
									Get Started Today!
								</v-btn>
							</div>
						</v-col>
					</v-row>
				</div>
			</div>
		</section>
		<!-- End Department of Defense Relationship -->

		<!-- Start About Area -->
		<!-- <section class="about-area section" id="aboutus">
			<div class="container">
				<div class="section-title text-center z-index9">
					<span>ABOUT PROJECT SPECTRUM</span>
					<h2>Supported by the Department of Defense</h2>
					<br />
				</div>
			</div>
			<div class="row">
				<div class="col-lg-1"></div>
				<div class="col-lg-6">
					<div style="text-align: right">
						<iframe
							height="350"
							width="100%"
							src="https://www.youtube.com/embed/a_v7zKoOcG4"
						/>
					</div>
				</div>
				<div class="col-lg-4">
					<div class="services-info-box">
						<div class="section-title">
							<h2 class="title position-relative pb-2 mb-3">
								Cybersecurity Areas
							</h2>
						</div>
						<ul class="list-unstyled mb-0">
							<li>
								<a class="text-dark"> Network cybersecurity </a>
							</li>
							<li>
								<a class="text-dark"> Access control </a>
							</li>
							<li>
								<a class="text-dark"> Education and workforce development </a>
							</li>
							<li>
								<a class="text-dark"> Cryptography </a>
							</li>
							<li>
								<a class="text-dark"> Malware </a>
							</li>
							<li>
								<a class="text-dark"> Compliance </a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section> -->
		<!-- End About Area -->

		<!-- Start Services Area -->
		<!-- <section class="section parallax-bg" id="services">
			<div class="container">
				<div class="section-title text-center z-index9">
					<span>OUR SERVICES</span>
					<h2 class="text-white">Training, Compliance, Tools</h2>
				</div>
				<div class="service-boxes-area">
					<div class="row">
						<div class="col-lg-4 col-md-6 col-sm-6">
							<div
								class="single-service-box mt-30 p-4 bg-white wow fadeIn"
								data-wow-delay="0.2s"
								data-wow-duration="1s"
							>
								<div class="icon">
									<i class="mdi mdi-desktop-mac-dashboard"></i>
								</div>
								<h3>Assessment Tools</h3>
								<p>Sign up for our Cyber Readiness Check</p>
							</div>
						</div>
						<div class="col-lg-4 col-md-6 col-sm-6">
							<div
								class="single-service-box mt-30 p-4 bg-white wow fadeIn"
								data-wow-delay="0.4s"
								data-wow-duration="1s"
							>
								<div class="icon">
									<i class="mdi mdi-responsive"></i>
								</div>
								<h3>Training and Workforce</h3>
								<p>Sign up for our online courses</p>
							</div>
						</div>
						<div class="col-lg-4 col-md-6 col-sm-6">
							<div
								class="single-service-box mt-30 p-4 bg-white wow fadeIn"
								data-wow-delay="0.6s"
								data-wow-duration="1s"
							>
								<div class="icon">
									<i class="mdi mdi-rocket"></i>
								</div>
								<h3>Tools and Services</h3>
								<p>Read our tool reviews</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<!-- End Services Area -->

		<!-- Start Faq's Area -->
		<!-- <section class="section">
			<div class="container">
				<div class="text-center section-title">
					<span> <strong> FAQs </strong> </span>
					<h2>Frequently Ask Questions</h2>
				</div>
				<div class="row mt-4">
					<div class="col-md-6">
						<div
							id="accordion"
							class="accordion accordion-faq wow fadeInUp"
							data-wow-duration="1s"
						>
							<div class="card bg-white">
								<a
									class="card-header text-dark bg-white py-4 collapsed"
									data-toggle="collapse"
									href="#collapseOne"
								>
									<span class="card-title">
										<strong> What is Project Spectrum?</strong>
									</span>
								</a>
								<div
									id="collapseOne"
									class="card-body collapse"
									data-parent="#accordion"
								>
									<p class="m-0">
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et dolore magna
										aliqua. Quis ipsum suspendisse ultrices gravida. simplify
										sustainable applications whereas adaptive schemas.
									</p>
								</div>
							</div>
							<div class="card bg-white">
								<a
									class="card-header text-dark bg-white py-4 collapsed"
									data-toggle="collapse"
									data-parent="#accordion"
									href="#collapseTwo"
								>
									<span class="card-title">
										<strong>
											Why should a small business like myself use Project
											Spectrum?</strong
										>
									</span>
								</a>
								<div
									id="collapseTwo"
									class="card-body collapse"
									data-parent="#accordion"
								>
									<p class="m-0">
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et dolore magna
										aliqua. Quis ipsum suspendisse ultrices gravida. simplify
										sustainable applications whereas adaptive schemas.
									</p>
								</div>
							</div>
							<div class="card bg-white">
								<a
									class="card-header text-dark bg-white py-4 collapsed"
									data-toggle="collapse"
									data-parent="#accordion"
									href="#collapseThree"
								>
									<span class="card-title">
										<strong> Who can benefit from Project Spectrum?</strong>
									</span>
								</a>
								<div
									id="collapseThree"
									class="card-body collapse pt-0"
									data-parent="#accordion"
								>
									<p class="m-0">
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et dolore magna
										aliqua. Quis ipsum suspendisse ultrices gravida. simplify
										sustainable applications whereas adaptive schemas.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div
							id="accordion1"
							class="accordion accordion-faq wow fadeInUp"
							data-wow-duration="1s"
						>
							<div class="card bg-white">
								<a
									class="card-header text-dark bg-white py-4 collapsed"
									data-toggle="collapse"
									data-parent="#accordion1"
									href="#collapseFour"
								>
									<span class="card-title">
										<strong>
											Why is cybersecurity important for small
											businesses?</strong
										>
									</span>
								</a>
								<div
									id="collapseFour"
									class="card-body collapse"
									data-parent="#accordion1"
								>
									<p class="m-0">
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et dolore magna
										aliqua. Quis ipsum suspendisse ultrices gravida. simplify
										sustainable applications whereas adaptive schemas.
									</p>
								</div>
							</div>
							<div class="card bg-white">
								<a
									class="card-header text-dark bg-white py-4 collapsed"
									data-toggle="collapse"
									data-parent="#accordion1"
									href="#collapseFive"
								>
									<span class="card-title">
										<strong>
											Is compliance certification such as CMMC required for
											small businesses?</strong
										>
									</span>
								</a>
								<div
									id="collapseFive"
									class="card-body collapse"
									data-parent="#accordion1"
								>
									<p class="m-0">
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et dolore magna
										aliqua. Quis ipsum suspendisse ultrices gravida. simplify
										sustainable applications whereas adaptive schemas.
									</p>
								</div>
							</div>
							<div class="card bg-white">
								<a
									class="card-header text-dark bg-white py-4 collapsed"
									data-toggle="collapse"
									data-parent="#accordion1"
									href="#collapseSix"
								>
									<span class="card-title">
										<strong>
											Is any commitment required for small businesses to use
											Project Spectrum?</strong
										>
									</span>
								</a>
								<div
									id="collapseSix"
									class="card-body collapse"
									data-parent="#accordion1"
								>
									<p class="m-0">
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et dolore magna
										aliqua. Quis ipsum suspendisse ultrices gravida. simplify
										sustainable applications whereas adaptive schemas.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section> -->
		<!-- End Faq's Area -->
		<InvitationModal
			v-if="isLoggedIn"
			ref="invitation-modal"
			@invite-accepted="getAccountData"
		/>
		<JoinRequestModal
			v-if="isLoggedIn"
			ref="join-request-modal"
			@request-accepted="getAccountData"
		/>
		<b-modal size="md" ref="welcome-admin-modal" title="Welcome" ok-only>
			<p class="my-2">
				We are happy to welcome you as the newest organization within Project
				Spectrum community! As an organization admin, you will be able to
				leverage the plethora of tools and services offered by Project Spectrum,
				including: Cyber Readiness Checks, advisory services, and assistance
				with every step of your customized cybersecurity journey. Additionally,
				you will have the ability to invite new members of your organization and
				manage them accordingly to gain insights into their individual training
				progress. Please feel free to take advantage of all of the resources at
				your disposal as well. We offer Cyber Readiness Checks for your
				organization, personalized cybersecurity training, virtual labs,
				informational webinars, Cyber Circuits Sessions (hear from industry
				experts), white papers, blogs, compliance tool reviews, and much more!
			</p>
		</b-modal>
	</div>
</template>
<script>
//WOW JS
import { WOW } from "wowjs";
import PromoBanner from "../components/promo-banner.vue";
// import Swiper styles
import "../assets/css/swiper.min.css";
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

import ButtonReadMore from "../components/button/btn-read-more.vue";
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

//ISOTOP JS
import "../assets/js/jquery.isotope.min.js";
import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
// import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
// import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
// import BotIcon from "../assets/images/logo/logo-dark-small.png";
import {
	setUser,
	isLoggedIn,
	getMigratedAdmin,
	setMigratedAdmin,
} from "../utils/authentication";
// ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

//import { VueBotUI } from 'vue-bot-ui';

//MAGNIFIC POPUP JS
import "magnific-popup/dist/jquery.magnific-popup.min.js"
import "magnific-popup/dist/magnific-popup.css"
import axios from "axios"
import InvitationModal from "./invitation-modal.vue"
import JoinRequestModal from "./join-request-modal.vue"
// import WelcomeAdminModal from "./welcome-admin-modal.vue"
import newsLists from "./news/newsLists.vue"	;

import RoadmapTimeline from "./library/widgets/roadmap-timeline.vue";
import SelectedSectionVideo from "./library/widgets/selected-section-video.vue";
import HomePageVideo from "./library/widgets/home-page-video.vue";
// import VideoPlayerWidget from "./library/widgets/video-player-widget.vue";
import SectionHero from '../components/page-components/index/spectrum-hero.vue';

import { EventBus } from "../utils/eventBus";

const ADDITIONAL_YPOS_SCROLL = 130;

export default {
  name: "index",
  components: {
    //VueBotUI,
	PromoBanner,
    InvitationModal,
    JoinRequestModal,
    RoadmapTimeline,
	newsLists,
	ButtonReadMore,
	// VideoPlayerWidget,
	SectionHero,
	SelectedSectionVideo,
	HomePageVideo,
  },
  props: {
    selectedSegment: String
  },
  watch: {
  '$route.query.segment': {
    handler(newValue) {
      if (newValue) {
        this.setTimelinelineItemOption(newValue);
      } else {
        // If query is cleared, reset the state
        this.timelineItem = null;
        this.shouldScroll = false;
      }
    },
    immediate: true
  },
  selectedSegment: {
    handler(newValue) {
      if (newValue) {
        this.setTimelinelineItemOption(newValue);
      }
    },
    immediate: true
  },
  $route: {
    handler(to) {
      if (to.path === '/') {
        // Explicitly prevent scrolling when on home route with no segment
		console.log("Home route with no segment");
        this.shouldScroll = false;
        this.timelineItem = null;
        this.isBackButtonClicked = true; // This should prevent scrollToBlueprint from executing
        
        // Force scroll to top
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    immediate: true
  },
  timelineItem: {
    handler(newValue) {
      if (!newValue) {
        this.shouldScroll = false;
      }
      this.isBlueprintOptionsOpened = false;
    }
  }
},
  created() {},
  mounted() {
    this.init()
    this.getNews()
    this.getCybercircuits()
    this.getEvents()
	// Handle deep linking via query parameters
	if (this.$route.query.segment || this.$route.query.root) {
		this.timelineItem = this.$route.query.segment;
		this.shouldScroll = true;
		// Delay scrolling slightly to ensure the component is fully mounted
		setTimeout(() => {
		this.scrollToBlueprint();
		}, 1000);
  }
  },
  data() {
    return {
      showdiv: 0,
      eventdiv: 1,
      datafilter: 0,
	  hasEventBanner: false,
      isBackButtonClicked: false,
      webinarItems: [],
      cybercircuitItems: [],
      newsItems: [],
	  selectedBusinessAssetItem: "DefenseIndustrialBase",
	  isMobileBusinessAssetItemsOpened: false,
	  businessAssets: [
		{
			assetItem: "DefenseIndustrialBase",
			assetImageSrc: "IndustryDefenseButton.svg",
		},
		{
			assetItem: "SmallBusinesses",
			assetImageSrc: "SmallBusinessButton.svg",
		},
		{
			assetItem: "Manufacturing",
			assetImageSrc: "ManufactureButton.svg",
		},
		{
			assetItem: "MPP",
			assetImageSrc: "MentorProtegeButton.svg",
		},
	  ],
	  businessAssetMap: {
		"DefenseIndustrialBase": "Defense Industrial Base",
		"SmallBusinesses": "Small Business",
		"Manufacturing": "Manufacturing",
		"MPP": "Mentor-Protégé Program"
	  },
	  mobileBusinessAssets: [],
	  isBlueprintOptionsOpened: false,
	  blueprintOptionItems: [
		{ 
			optionItem: "Cybersecurity", 
			optionValue: "Cybersecurity", 
		},
		{ 
			optionItem:"ProjectSpectrum", 
			optionValue:"Project Spectrum", 
		},
		{ 
			optionItem:"SpectrumManufacturers", 
			optionValue:"Spectrum for Manufacturers", 
		},
		{ 
			optionItem:"UnderstandingData", 
			optionValue:"Understanding My Data", 
		},
		{ 
			optionItem:"BusinessTools", 
			optionValue:"Tools for My Business", 
		},
		{ 
			optionItem:"CMMC", 
			optionValue:"CMMC", 
		},
		{ 
			optionItem:"NIST800-171", 
			optionValue:"NIST 800-171", 
		},
	  ],
      timelineItem: null,
	  availableVideos: {
	    // "Cybersecurity": {
		// 	videoId: "CYBER_SECURITY_007",
		// 	videoSrc: "",
		// 	videoTitle: "",
		// 	videoShare: window.location.origin + "/#/?segment=Cybersecurity",
		// 	videoTextDescription: ``,
		// 	videoThumbnail: "",
		// 	isMP4Video: true,
		// },
		"ProjectSpectrum": {
			videoId: "VIDEO_WHY_PROJECT_SPECTRUM_001",
			videoSrc: "https://projectspectrumlearning.io/tsv/MissionVideosCombined_Final_Captioned.mp4",
			videoTitle: "Project Spectrum Mission",
			videoShare: window.location.origin + "/#/?segment=ProjectSpectrum",
			videoTextDescription: `From Advanced Nation-State attacks infiltrating U.S. defense contractors to critical infrastructure attacks (ICS/SCADA exploitation) manipulating power grids, water treatment facilities, pipelines, or rail control systems, cybersecurity matters more than ever.<br><br>Our mission is to secure the Defense Industrial Base (DIB) through Cybersecurity Maturity Model Certification preparation while educating small to medium size businesses on cybersecurity best practices.`,
			videoThumbnail: "video-images/Project_Spectrum_Mission",
			isMP4Video: true,
		},
		"SpectrumManufacturers": {
			videoId: "SPECTRUM_MANUFACTURERS_003",
			videoSrc: "https://projectspectrumlearning.io/tsv/PSCAS_WhyCybersecurityIsCriticalInManufacturing.mp4",
			videoTitle: "Cybersecurity in Manufacturing",
			videoShare: window.location.origin + "/#/?segment=SpectrumManufacturers",
			videoTextDescription: "Manufacturing is disproportionately impacted by cybersecurity threats, with nearly 50% of cyberattacks in the defense industrial base linked to foreign ownership, control, or influence. While foreign investment can support business growth, it also raises critical concerns about access and control—especially in U.S.-based manufacturing. Many of these companies, often small and operating on outdated IT and OT systems, lack the infrastructure and safeguards to defend against nation-state or domestic attacks. This video explains why the manufacturing sector remains a prime target and highlights the urgent need for stronger cyber protection.",
			videoThumbnail: "https://projectspectrumlearning.io/tsv/PSCAS_WhyCybersecurityisCriticalinManufacturing_Thumbnail.png",
			isMP4Video: true,
		},
		"CMMC": {
			videoId: "VIDEO_WHAT_IS_CMMC_002",
			videoSrc: "https://projectspectrumlearning.io/tsv/WhatisCMMC_Final.mp4",
			videoTitle: "What is CMMC?",
			videoShare:  window.location.origin + "/#/?segment=CMMC",
			videoTextDescription: "The Cybersecurity Maturity Model Certification is a program designed to enforce the protection of sensitive unclassified information shared by the Department of Defense with its contractors and subcontractors. The program provides the DoD with increased assurance that contractors and subcontractors are meeting the cybersecurity requirements for nonfederal systems processing controlled unclassified information.",
			videoThumbnail: "https://projectspectrumlearning.io/tsv/WhatisCMMC_WebsiteThumbnail.png",
			isMP4Video: true,
		},
		"NIST800-171": {
			videoId: "NIST800_171_004",
			videoSrc: "https://projectspectrumlearning.io/tsv/PSCAS_NISTStandards.mp4",
			videoTitle: "Understanding The Importance of NIST Standards",
			videoShare: window.location.origin + "/#/?segment=NIST800-171",
			videoTextDescription: "NIST standards, including 800-171 and 800-53, provide the foundation for protecting sensitive federal data across the supply chain. This video explains how small businesses, especially subcontractors handling FCI and CUI, can create national security risks without proper safeguards. It also highlights how the Cybersecurity Maturity Model Certification (CMMC) builds on these NIST frameworks to guide compliance. Project Spectrum can help companies assess their cybersecurity posture and take proactive steps toward securing their systems.",
			videoThumbnail: "https://projectspectrumlearning.io/tsv/PSCAS_NISTStandards_Thumbnail.png",
			isMP4Video: true,
		},
		"UnderstandingData": {
			videoId: "UNDERSTANDING_MY_DATA_005",
			videoSrc: "https://projectspectrumlearning.io/tsv/understanding_your_data_final_.mp4",
			videoTitle: "Intro to Understanding How to Protect Your Data",
			videoShare: window.location.origin + "/#/?segment=UnderstandingData",
			videoTextDescription: "Let’s be honest, most small business owners don’t wake up thinking about cybersecurity. But in today’s connected world, that oversight could cost you.<br><br>In this video, we break down why data awareness is your first line of defense to protect what you’ve built! Together, we’ll review what foundational steps you can take to secure your business, whether you’re running a logistics firm, managing a health clinic, or operating a mom-and-pop manufacturing shop.",
			videoThumbnail: "https://projectspectrumlearning.io/tsv/understanding%20your%20data%20thumbnail.jpg",
			isMP4Video: true,
		},
		"BusinessTools": {
			videoId: "TOOLS_FOR_BUSINESS_006",
			videoSrc: "https://projectspectrumlearning.io/tsv/toolsforyourbusiness_video.mp4",
			videoTitle: "Intro to Choosing Cybersecurity Tools for Small Business",
			videoShare: window.location.origin + "/#/?segment=BusinessTools",
			videoTextDescription: "You’ve done the groundwork: mapped your data, trained your team, and patched the basics. But now comes the big question: what cybersecurity tools does your business (actually) need? What's the right fit for you?  The cybersecurity marketplace is overwhelming, filled with often meaningless buzzwords to individuals unfamiliar with cybersecurity jargon. This video is your introductory guide to making practical, defensible tool decisions grounded in actual risk, in plain language.",
			videoThumbnail: "https://projectspectrumlearning.io/tsv/toolsforyourbusiness_thumbnail.png",
			isMP4Video: true,
		},
	  },
      availableTimelines: {
        "Cybersecurity": "Cybersecurity",
        "ProjectSpectrum": "Project Spectrum",
        "SpectrumManufacturers": "Spectrum For Manufacturers",
        "UnderstandingData": "Your Data",
        "BusinessTools": "Business Tools",
        "CMMC": "CMMC",
        "NIST800-171": "NIST 800-171",
      },
      timelineItems: {
          "Cybersecurity": [
            {
                title: "Cyber Awareness",
                content: "Gain knowledge of common threats and attack vectors",
				videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/96e7d4dac4d6001078b6ce8ed5912bc2/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F96e7d4dac4d6001078b6ce8ed5912bc2%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D10s%26height%3D600",
				videoNum: "1.1",
            },
            {
                title: "Study Best Practices",
                content: "Learn about fundamental cybersecurity practices such as data encryption, software updates, and password management",
				videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/8526408ff71d724f663088320db8d080/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F8526408ff71d724f663088320db8d080%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D58s%26height%3D600",
				videoNum: "1.2",
            },
            {
                title: "Strategies of Readiness",
                content: "Gain knowledge on the importance of learning cyber frameworks and standards",
				videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/eac719cd2d4e8f95271eca8d732a3867/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Feac719cd2d4e8f95271eca8d732a3867%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D40s%26height%3D600",
				videoNum: "1.3",
            },
			{
				title: "Kill Chain",
				content: "Learn about the framework developed by Lockheed Martin to help understand and counteract cyber threats",
				videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/84c1d8a1face5b2988026e81d93d78cc/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F84c1d8a1face5b2988026e81d93d78cc%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m52s%26height%3D600",
				videoNum: "1.4",
			},
          ],

        //   "ProjectSpectrum": [
        //     {
        //       title: "Our Core Objectives",
        //       content: "Obtain an overview of the core objectives and scope of Project Spectrum",
        //       videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/4a14350bed121fb184eb4dd0e7c86ef5/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F4a14350bed121fb184eb4dd0e7c86ef5%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D14s%26height%3D600",
		// 	  videoNum: "2.1",
        //     },
        //     {
        //       title: "View Case Studies",
        //       content: "Examine case studies and success stories pertaining to the utilization of Project Spectrum",
        //       videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/9455f5cfa31e0f90d18eb46656684c2e/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F9455f5cfa31e0f90d18eb46656684c2e%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D18s%26height%3D600",
		// 	  videoNum: "2.2",
        //     },
        //     {
        //       title: "Resource Overview",
        //       content: "Project Spectrum many resources at your side",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/d9cd68e19e5af740e90b792bb1d9390b/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fd9cd68e19e5af740e90b792bb1d9390b%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m25s%26height%3D600",
		// 	  videoNum: "2.3",
        //     },
        //   ],

        //   "SpectrumManufacturers": [
		// 	{
		// 	  title: "Industry Forecasting",
		// 	  content: "Keep abreast of current technological advancements in the field",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/aed38f245dea01905618525faeff0830/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Faed38f245dea01905618525faeff0830%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m9s%26height%3D600",
		// 	  videoNum: "3.1",
		// 	},
		// 	{
		// 	  title: "Prioritize Optimization",
		// 	  content: "Examine automation as a means of streamlining current procedures and systems",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/b6a7b4691f7260e357f440eb12021349/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fb6a7b4691f7260e357f440eb12021349%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m8s%26height%3D600",
		// 	  videoNum: "3.2",
		// 	},
		// 	{
		// 	  title: "Manufacturing Vulnerabilities",
		// 	  content: "Protect your operations and facilities",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/a21777f32a5b9bd686a7287f61131705/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fa21777f32a5b9bd686a7287f61131705%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D50s%26height%3D600",
		// 	  videoNum: "3.3",
		// 	},
		//   ],

        //   "UnderstandingData": [
		// 	{
		// 	  title: "Identify Data Types",
		// 	  content: "Define the types of data the business will collect, process, and store",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/23fe2247dc7b8356f1ca09e6bc712c38/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F23fe2247dc7b8356f1ca09e6bc712c38%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D56s%26height%3D600",
		// 	  videoNum: "4.1",
		// 	},
		// 	{
		// 	  title: "Decision Making",
		// 	  content: "Consider data analysis and visualization techniques to draw conclusions from your data",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/65ce5269ae9a23bc961f8c0e104e0531/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F65ce5269ae9a23bc961f8c0e104e0531%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m41s%26height%3D600",
		// 	  videoNum: "4.2",
		// 	},
		// 	{
		// 	  title: "Implementation",
		// 	  content: "Implement governance procedure for quality, security, and compliance",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/9d60180bb746b051385e9bf7a4d219a2/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F9d60180bb746b051385e9bf7a4d219a2%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m03s%26height%3D600",
		// 	  videoNum: "4.3",
		// 	},
		//   ],

        //   "BusinessTools": [
		// 	{
		// 	  title: "Essential Requirements",
		// 	  content: "Determine your company's unique requirements and objectives",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/d4376d5a04169d5b9ae4ed14046824e6/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fd4376d5a04169d5b9ae4ed14046824e6%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D51s%26height%3D600",
		// 	  videoNum: "5.1",
		// 	},
		// 	{
		// 	  title: "Equip Yourself",
		// 	  content: "Research and evaluate tools specific to your industry and business size",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/2a01eb3a5e8c20225e3e9253658c81c5/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F2a01eb3a5e8c20225e3e9253658c81c5%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m13s%26height%3D600",
		// 	  videoNum: "5.2",
		// 	},
		// 	{
		// 	  title: "Final Determination",
		// 	  content: "Selecting your final option, consider integration and cost scalability",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/832df5241c3a54e4635d48037a894212/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F832df5241c3a54e4635d48037a894212%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m24s%26height%3D600",
		// 	  videoNum: "5.3",
		// 	},
		//   ],

        //   "CMMC": [
		// 	{
		// 	  title: "What is CMMC?",
		// 	  content: "Learn about the CMMC program of the Department of Defense (DoD)",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/ca129ca1db7d642672672e7fab2b8cc4/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Fca129ca1db7d642672672e7fab2b8cc4%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m26s%26height%3D600",
		// 	  videoNum: "6.1",
		// 	  isVideoUnavailable: true,
		// 	},
		// 	{
		// 	  title: "What is Level 1?",
		// 	  content: "Learn about the foundational tier of CMMC",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/4bcb68d73d3d3f42236370a426264857/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F4bcb68d73d3d3f42236370a426264857%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D1m20s%26height%3D600",
		// 	  videoNum: "6.2",
		// 	  isVideoUnavailable: true,
		// 	},
		// 	{
		// 	  title: "What is Level 2?",
		// 	  content: "Learn about the advanced tier of CMMC",
		// 	  videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/91da3ee47ac59d2f4d3cbc2c30a7832f/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F91da3ee47ac59d2f4d3cbc2c30a7832f%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m06s%26height%3D600",
		// 	  videoNum: "6.3",
		// 	  isVideoUnavailable: true,
		// 	},
		//   ],

        //   "NIST800-171": [
		// 	{
		// 		title: "What is NIST 800-171?",
		// 		content: "Learn about a set of security framework requirements issued by DoD",
		// 		videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/af44010cc39f19ddc44e7976d37cb095/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Faf44010cc39f19ddc44e7976d37cb095%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D22s%26height%3D600",
		// 		videoNum: "7.1",
		// 	},
		// 	{
		// 		title: "NIST 800-171 vs CMMC Level 1",
		// 		content: "What are the differences between these two?",
		// 		videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/05509b84b6db3c0ebadf3cd2e72d6ba0/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F05509b84b6db3c0ebadf3cd2e72d6ba0%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D57s%26height%3D600",
		// 		videoNum: "7.2",
		// 	},
		// 	{
		// 		title: "NIST 800-171 vs CMMC Level 2",
		// 		content: "What are the differences between these two?",
		// 		videoSrc: "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/7c87af2802c6f1b3332670345477a295/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F7c87af2802c6f1b3332670345477a295%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D41s%26height%3D600",
		// 		videoNum: "7.3",
		// 	},
		//   ],
      },
	  showOverview: false,
      /*messageData: [],
      botTyping: false,
      inputDisable: false,
      botOptions: {
        botAvatarImg: BotIcon,
        botTitle: 'Project Spectrum Bot',
        boardContentBg: '#f4f4f4',
        msgBubbleBgBot: '#fff',
        inputPlaceholder: 'Type query here ...',
        inputDisableBg: '#fff',
        inputDisablePlaceholder: 'Hit the buttons above to respond',
        bubbleBtnSize: 50,
        client: null,
      },*/
      shouldScroll: false,
    }
  },
  computed: {
    items() {
      return this.newsItems
    },
    webinaritems() {
      return this.webinarItems
    },
    cybercircuititems() {
      return this.cybercircuitItems
    },
    roadmapTimelineTitle(){
      return this.availableTimelines[this.timelineItem];
    },
    selectedRoadmapTimeline() {
      return this.timelineItems[this.timelineItem];
    },
	selectedVideo() {
	  return this.availableVideos[this.timelineItem];
	},
	selectedBlueprintItemValue() {
		return this.blueprintOptionItems.find(({ optionItem }) => optionItem === this.timelineItem)?.optionValue;
	},
	computeCompanyPartnerTextClass() {
		if (this.$vuetify.breakpoint.md) {
			return "company-partners-text-info-md";
		}
		else if (this.$vuetify.breakpoint.sm) {
			return "company-partners-text-info-sm";
		}
		else if (this.$vuetify.breakpoint.xs) {
			return "company-partners-text-info-xs";
		}
	},
	computeCompanyPartnerTextContainerClass() {
		return (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) ? "20px" : 0;
	},
	computeBlueoptionsLeftMargin() {
		return this.$vuetify.breakpoint.xs ? "ml-0" : "ml-3";
	},
	isMobileView() {
		return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs);
	},
	businessItem() {
		return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) ? "business-item-xs-sm" : "business-item-md-lg-lx";
	},
	resizeCustomerTitle() {
			if(this.$vuetify.breakpoint.md) {
				return "32px";
			}
			else if(this.$vuetify.breakpoint.sm) {
				return "28px";
			}
			else if(this.$vuetify.breakpoint.xs) {
				return "24px";
			}
			else {
				return "36px";
			}
		},
	isOverviewVisible() {
		if(this.$vuetify.breakpoint.xs) {
			return this.showOverview;
		}
		else {
			this.showOverview = false;
			return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl;
		}
	}
  },
  beforeMount() {
    if (isLoggedIn()) {
      this.getAccountData()
    }
  },
  methods: {
	applyEventBannerStyles(showEventBanner) {
		this.hasEventBanner = showEventBanner;
	},
    OpenMPPSummitLearnMore() {
      if (isLoggedIn()) {
        /** Track User Activity */
        axios
          .post("/api/spectranalytics/authenticated", {
            event: "click",
            description: "Carousal DOD summit Learn More",
          })
          .then(() => {
            console.log("Tracked User Activity")
          })
          .catch((error) => {
            handleApiError(error, null)
          })
      } else {
        /** Track Anonymous Activity */
        axios
          .post("/api/spectranalytics/anonymous", {
            event: "click",
            description: "Carousal DOD summit Learn More",
          })
          .then(() => {
            console.log("Tracked Anonymous Activity")
          })
          .catch((error) => {
            console.log(error)
          })
      }
      window.open(
        "https://www.projectspectrum.io/#/blogdetail?id=0c23f1fa-9912-49fe-bdd7-c67a5bb58f75",
        "_blank"
      )
    },
    getAccountData() {
      this.busy = true
      axios
        .get(`/api/user/`)
        .then((response) => {
          /** Set User in Store */
          setUser(response.data)
          /** Check if the account needs migrated */
          console.log("response.data.memberOption", response.data.memberOption)
          console.log("getMigratedAdmin", getMigratedAdmin())
          if (getMigratedAdmin() || response.data.migratedAdmin) {
            this.$refs["welcome-admin-modal"].show()
            setMigratedAdmin()
          }

					/** Check if the account needs welcome message */
					if (response.data.memberOption) {
						this.$router.push({ path: "/my-account" });
					}
				})
				.catch((error) => {})
				.finally(() => {
					this.busy = false;
				});
		},
		/*botStart() {
      // Get token if you want to build a private bot
      // Request first message here
      // Fake typing for the first message
      this.botTyping = true;
      setTimeout(() => {
        this.botTyping = false;
        this.messageData.push({
          agent: 'bot',
          type: 'text',
          text: 'Hello, My name is PS Bot. Do you have any questions regarding Project Spectrum?',
        });
      }, 1000);
    },
    msgSend(value) {
      // Push the user's message to board
      this.messageData.push({
        agent: 'user',
        type: 'text',
        text: value.text,
      });
      this.getResponse(value.text);
    },
    // Submit the message from user to bot API, then get the response from Bot
    getResponse(txt) {
      // Loading
      this.botTyping = true;
      axios
        .get(`/api/chatbot/`, { params: { query: txt } })
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            const replyMessage = {
              agent: 'bot',
              text: response.data,
            };
            this.inputDisable = false;
            this.messageData.push(replyMessage);
            // finish
            this.botTyping = false;
          }
        });
    },*/
		setDataFilter(divid) {
			this.datafilter = divid;
		},
		setDiv(divid) {
			this.showdiv = divid;
			//console.log(this.showdiv);
		},
		setEventdiv(divid) {
			this.eventdiv = divid;
			//console.log(this.eventdiv);
		},
		init() {
			this.initMainSlider();
			this.initBackgroundImage();
			this.initWowAnimation();
			this.initAccordian();
			this.windowScroll();
			this.initTestimonialSlider();
			/* The footer height no longer needs to be set */
			// this.initFooterHeight();
			this.initIsotop();
			this.initMagnificPopup();
			this.initScaleImage();

			this.mobileBusinessAssets = [ ...this.businessAssets ];
		},
		async getNews() {
			//console.log('GetNews()');
			/*  API call to resources/news */
			axios
				.get("/api/resources/news")
				.then((response) => {
					/* choose the 3 latest news items to display */
					this.newsItems = response.data.Items.slice(0, 3);
				})
				.catch((error) => {
					console.error(error);
					//console.log('newsitems');
				});
		},
		async getEvents() {
			/*  API call to resources/news */
			axios
				.get("/api/resources/events")
				.then((response) => {
					/* choose the 2 latest event items to display */
					this.webinarItems = response.data.Items.slice(0, 3);
					for (let i = 0; i < this.webinarItems.length; i++) {
						this.webinarItems[i].description =
							this.webinarItems[i].description?.length < 100
								? this.webinarItems[i].description
								: this.webinarItems[i].description?.substr(0, 100) + "...";
					}
				})
				.catch((error) => {
					console.error(error);
				});
		},
		async getCybercircuits() {
			/*  API call to resources/news */
			axios
				.get("/api/resources/cybercircuits")
				.then((response) => {
					/* choose the 2 cybercircuits items to display */
					this.cybercircuitItems = response.data.Items.slice(0, 3);
					//console.log(this.cybercircuitItems);
				})
				.catch((error) => {
					console.error(error);
				});
		},
		/*----MAIN ANIMATION-----*/
		initMainSlider() {
			const SECOND = 1000; // milliseconds

			// init Swiper:
			new Swiper(this.$refs.swiper, {
				// configure Swiper to use modules
				modules: [Navigation, Pagination, Autoplay],

				loop: true,
				autoplay: {
					delay: 4 * SECOND,
					disableOnInteraction: false,
				},
				speed: 2 * SECOND,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},

				// Events
				on: {
					slideChange: (swiper) => {
						this.activeIndex = swiper.realIndex;
					},
				},
			});
		},
		/*----BACKGROUND IMAGE-----*/
		initBackgroundImage() {
			$(".bg-image").css("background", function () {
				var bg =
					"url(" + $(this).data("image-src") + ") no-repeat center center";
				return bg;
			});
		},
		initFooterHeight() {
			var footerHeight = $("footer").outerHeight();
			$(".main-content").css("margin-bottom", footerHeight);
		},
		/*----WOW ANIMATION-----*/
		initWowAnimation() {
			var length = $(".wow").length;
			if (length >= 1) {
				const wow = new WOW({
					boxClass: "wow",
					animateClass: "animated",
					offset: 0,
				});
				wow.init();
			}
		},
		/*----ONSCROLL JS-----*/
		windowScroll() {
			var self = this;
			$(window).on("scroll", function () {
				//self.initCounter();
			});
		},
		/*----ACCORDIAN-----*/
		initAccordian() {
			$(".question-card").on("click", function () {
				if ($(this).hasClass("active")) {
					$(".question-card").removeClass("active");
					$(this).removeClass("active");
				} else {
					$(".question-card").removeClass("active");
					$(this).addClass("active");
				}
			});
		},
		/*----TESTIMONIAL SLIDER-----*/
		initTestimonialSlider() {
			if ($(".swiper-container").length > 0) {
				var swiper = new Swiper(".client-container", {
					slidesPerView: 1,
					draggable: true,
					spaceBetween: 10,
					//init: false,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
					breakpoints: {
						640: {
							slidesPerView: 1,
							spaceBetween: 20,
						},
						768: {
							slidesPerView: 2,
							spaceBetween: 40,
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 50,
						},
					},
				});
			}
		},
		/*----ISOTOP JS-----*/
		initIsotop() {
			var $container = $(".portfolio-items");
			$container.imagesLoaded(function () {
				$container.isotope({
					filter: "*",
				});
			});

			$(".portfolio-filter li a").click(function () {
				$(".portfolio-filter .current").removeClass("current");
				$(this).addClass("current");
				var selector = $(this).attr("data-filter");
				$container.isotope({
					filter: selector,
					animationOptions: {
						duration: 750,
						easing: "linear",
						queue: false,
					},
				});
				return false;
			});
		},
		/*----MAGNIFIC POPUP JS-----*/
		initMagnificPopup() {
			if (".portfolio-items".length > 0) {
				$(".portfolio-items").each(function () {
					$(this).magnificPopup({
						delegate: ".js-zoom-gallery",
						type: "image",
						gallery: {
							enabled: true,
						},
					});
				});
			}
		},
		initScaleImage() {
			var controller = new ScrollMagic.Controller();
			var slides = $(".scale-image");
			for (var i = 0; i < slides.length; i++) {
				var image = $("img", slides[i]);
				var tween = TweenMax.to(image, 1, { scale: 1.2 });
				var scene = new ScrollMagic.Scene({
					triggerElement: slides[i],
					duration: "200%",
					triggerHook: "onEnter",
				})
					.setTween(tween)
					.addTo(controller);
			}
		},
		goToCyberReadinessCheck() {
			this.$router.push('cyber-readiness-check');
			EventBus.$emit("activate-indicated-menu-item", "Resources");
		},
		setSelectedTimelineItem(selectedSegmentName) {
			this.timelineItem = selectedSegmentName;
		},
		setTimelinelineItemOption(optionItem) {
			this.timelineItem = optionItem;
			this.shouldScroll = true;
			this.isBackButtonClicked = false;
			setTimeout(() => {
				this.scrollToBlueprint();
			}, 1000);
		},
		scrollToBlueprint() {
			const videoElement = document.getElementById('selected-video');
			const blueprintElement = document.getElementById('blueprint-options-list-container');
			if (videoElement || blueprintElement) {
				const rectElement = videoElement || blueprintElement;
				const rect = rectElement.getBoundingClientRect();
				const ypos = rect.top + window.scrollY - ADDITIONAL_YPOS_SCROLL;
				window.scrollTo({ top: ypos, behavior: 'smooth' });
				this.shouldScroll = false;
			}
		},
		setOverviewText() {
			this.showOverview = !this.showOverview;
		},
		openMobileBusinessItemOptions() {
			this.isMobileBusinessAssetItemsOpened = !this.isMobileBusinessAssetItemsOpened;
		},
		selectBusinessItemOptions(assetItemOption) {
			this.selectedBusinessAssetItem = assetItemOption;

			const assetItemIndex = this.mobileBusinessAssets.findIndex((item) => item.assetItem === assetItemOption);
			const selectedAssetItem = this.mobileBusinessAssets[assetItemIndex];

			this.mobileBusinessAssets.splice(assetItemIndex, 1);
			this.mobileBusinessAssets = [ selectedAssetItem, ...this.mobileBusinessAssets ];

			if(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) {
				this.openMobileBusinessItemOptions();
			}
		},
		activateMenuItemTab(menuItem) {
			EventBus.$emit("activate-indicated-menu-item", menuItem);
		},
		scrollToVideo() {
			if (this.$refs.videoSection) {
				this.$refs.videoSection.$el.scrollIntoView({ 
					behavior: 'smooth',
					block: 'start'
				});
			}
		},
		handleBackButtonClick() {
			this.isBackButtonClicked = true;
			this.shouldScroll = false;
			this.timelineItem = null;
			  // Add these lines to force a clean state
			if (this.$route.query.segment) {
				// Remove the segment query parameter without triggering unnecessary watchers
				this.$router.replace({ path: '/' }).catch(() => {});
			}
			// Force scroll to top after a short delay to ensure state updates are processed
			setTimeout(() => {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}, 100);
			}
	},
};
</script>
<style scoped>

p, ul, li {
	font-weight: 500 !important;
}

ul.new-style {
	list-style-position: outside;
	margin-left: 1.2em;
	text-align: left;
}

li.new-style {
	list-style-type: "\2714\0020";
	padding-inline-start: 0.5em;
	padding-bottom: 0.6em;
}

.box {
	box-sizing: border-box;
	border: 3px solid transparent;
	background-clip: padding-box;
}

.cover {
	object-fit: cover;
	height: 225px;
	width: 100%;
}
.news-cover-small {
	object-fit: cover;
	height: 120px;
	width: 100%;
}

.slide-mpp {
	background: url("~@/assets/images/slider-img/mentor.jpg");
}
@media (min-width: 1100px) {
	.slide-cmmc {
		background: url("~@/assets/images/slider-img/cybercircuits.jpg");
	}
	.slide-mpp-summit {
		background: url("~@/assets/images/slider-img/mpp-banner2.png");
	}
	.slide-sbt {
		background: url("https://gcassets.projectspectrum.io/events/SmallBusinnessWeek.png");
	}
}
@media (max-width: 1101px) {
	.slide-cmmc {
		background: url("~@/assets/images/slider-img/cybercircuits_mobile.png");
	}
	.slide-mpp-summit {
		background: url("~@/assets/images/slider-img/mpp-banner2.png");
	}
	.slide-sbt {
		background: url("https://gcassets.projectspectrum.io/events/SmallBusinnessWeek.png");
		background-size: contain !important;
		background-repeat: no-repeat;
	}
}
.slide-readiness {
	background: url("~@/assets/images/slider-img/readiness.jpg");
}

.slide-main {
	background: url("~@/assets/images/slider-img/homeSlider.jpg");
}
.embed-youtube {
	position: relative;
	padding-bottom: 40%; /* - 16:9 aspect ratio (most common)r */
	/* padding-bottom: 62.5%; - 16:10 aspect ratio */
	/* padding-bottom: 75%; - 4:3 aspect ratio */
	padding-top: 30px;
	height: 0;
	overflow: hidden;
}

.embed-youtube iframe,
.embed-youtube object,
.embed-youtube embed {
	border: 0;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.cater-business h2 {
	font-family: Rajdhani !important;
	font-size: 32px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
}
.cater-business li {
	font-family: Rajdhani;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
}
.cater-business > button > .v-btn__content {
    color: #FFFFFF;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
}
.video-player-box {
	width: 95%;
	height: 280px;
}

.section-cybersecurity h2 {
  margin: 0;
  margin-bottom: 40px;
}


.blueprint-options {
	width: 100%;
	min-width: 315px;
	min-height: 248px;
	border-radius: 10px;
	background-color: #D5D7D7;
	/* margin-top: 40px; */
	padding-top: 20px;
	padding-bottom: 20px;
}
.blueprint-option-title {
	color: #272727;
	font-family: Rajdhani;
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: 24px;
}
.blueprint-options-container {
	width: 45%;
	min-width: 290px;
	height: auto;
}
.blueprint-option-item {
	width: 100%;
	height: 50px;
	border-radius: 10px;
	background: #FFFFFF;
	color: #272727;
	font-family: Rajdhani;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	text-align: left;
}
.blueprint-option-item:first-child {
	position: relative;
}
.blueprint-option-item:not(:first-child) {
	cursor: pointer;
}
.blueprint-option-item:not(:first-child):hover {
	background-color: #87CEFA;
	border: 2px solid #0000ff;
	font-weight: 700;
	font-size: 18px;
}
.selected-blueprint-option {
	background-color: #87CEFA;
	font-weight: 700;
	font-size: 18px;
}
.business-item {
	height: 120px;
	display: flex;
	align-items: center;
}
.business-item-md-lg-lx {
	justify-content: center;
}
.business-item-xs-sm {
	justify-content: flex-start;
}
.business-item:hover {
	cursor: pointer;
	background-color: #E9ECF5 !important;
}
.business-items {
	height: auto;
	border-radius: 10px;
	border: 1px solid black;
	overflow: hidden;
	position: relative;
}
.left-relevant-information {
	border-radius: 10px;
	background-color: #E9EDF6;
	position: relative;
	padding: 20px;
}
.relevant-information-text h6 {
	font-family: Rajdhani;
	font-size: 16px;
	font-style: normal;
	line-height: normal;
	font-weight: 700;
}
.relevant-information-text p, .relevant-information-text li {
	font-family: Rajdhani;
	font-size: 16px;
	font-style: normal;
	line-height: 20px;
	font-weight: 400;
}
.relevant-information-text ul.target-audiences > li {
	list-style-type: none;
}

.company-partners-container {
	min-height: 240px;
	background-color: #D5D7D7;
	margin-bottom: 40px;
}
.company-partners-container-text-info {
	color: #424EC4;
	font-family: Rajdhani;
	font-size: 32px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
}
.company-partners-text-info-md {
	font-size: 30px;
}
.company-partners-text-info-sm {
	font-size: 28px;
}
.company-partners-text-info-xs {
	font-size: 24px;
}
.last-image-class {
	padding-right: 20px !important;
}

.customer-relationship-container {
	height: auto;
	margin: 0;
	padding: 0;
	background-image: url('../assets/images/RelationshipDoDFooterBanner.png');
	background-size: cover;
}
.customer-relationship-content {
	min-height: 320px;
}
.customer-relationship-title {
	color: #FFFFFF;
	text-align: center;
	font-family: "GeomGraphic";
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	margin: 15px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}
.customer-relationship-text {
	color: #E6E6E6;
	text-align: center;
	font-family: "Open Sans", sans-serif;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	padding: 5px;
}
.customer-relationship-text span {
	word-wrap: break-word;
}
.button-container {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin-top: 15px;
	margin-bottom: 15px;
}
</style>
